import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import AdminNav from "./AdminNav";
import AdminHome from "./AdminHome";

// Lazy-loaded modules (code splitting)
const BrandProfilesModule = lazy(() => import("./BrandProfilesModule"));
const QuestionnaireBuilder = lazy(() => import("../DynamicQuestionnaire/admin/QuestionnaireBuilder"));
const ResponsesManager = lazy(() => import("../DynamicQuestionnaire/admin/ResponsesManager"));
const AdminDashboard = lazy(() => import("./AdminDashboard"));
const OnboardingModule = lazy(() => import("./OnboardingModule"));
const ManualBrandPageModule = lazy(() => import("./ManualBrandPageModule"));

const Loader = () => (
  <div className="flex items-center justify-center w-full h-full p-10">
    <div className="w-8 h-8 border-4 border-primary-green border-t-transparent rounded-full animate-spin" />
  </div>
);

/**
 * AdminPortal
 * Wraps admin navigation and nested routes.
 */
const AdminPortal = () => {
  return (
    <div className="flex bg-[#111111] text-white min-h-screen">
      {/* Side navigation */}
      <AdminNav />
      {/* Main content */}
      <main className="flex-1 overflow-auto">
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<AdminHome />} />
            <Route path="legacy-profiles" element={<BrandProfilesModule />} />
            <Route path="questionnaire/templates" element={<QuestionnaireBuilder />} />
            <Route path="questionnaire/responses" element={<ResponsesManager />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="onboarding" element={<OnboardingModule />} />
            <Route path="manual-brand-pages" element={<ManualBrandPageModule />} />
            {/* Redirect any unknown paths back to home */}
            <Route path="*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </Suspense>
      </main>
    </div>
  );
};

export default AdminPortal;